// PrivateSection.js

import React from 'react';
import { SidebarComponent, SidebarContext } from 'components/Sidebar';
import HeaderComponent from 'components/Header';
import PrivateRoutes from './PrivateRoutes';
import Footer from 'components/Footer';

function PrivateSection({ userRole }) {
    return (
        <SidebarContext>
            {/* Inject responsive styles for mainBlock margin */}
            <style>{`
                .private-main-block {
                    margin-left: 255px;
                    padding: 5px 10px;
                    min-width: 0;
                }
                @media (max-width: 1080px) {
                    .private-main-block {
                        margin-left: 0;
                        /* MYID-H9 — leave room for the fixed hamburger
                           (left:12 + 40px width + 8px breathing). Without
                           this, the brand logo collides with the
                           hamburger on first paint. */
                        padding-left: 60px;
                    }
                }
            `}</style>
            <div style={{ display: 'flex', height: '100%' }}>
                <SidebarComponent />
                <div className="private-main-block" style={{ flexGrow: 1 }}>
                    <HeaderComponent />
                    <div style={{ marginTop: 10, marginBottom: 50 }}>
                        <PrivateRoutes userRole={userRole} />
                    </div>
                </div>
            </div>
            <Footer />
        </SidebarContext>
    );
}

export default PrivateSection;
